function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { CONNOTATIONS } from "@neru/types";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { newNotification, removeNotification } from "../modules";
var useAppDispatch = function() {
    return useDispatch();
};
var _obj;
var defaultHeaders = (_obj = {}, _define_property(_obj, CONNOTATIONS.announcement, "Announcement!"), _define_property(_obj, CONNOTATIONS.success, "Success!"), _define_property(_obj, CONNOTATIONS.alert, "Error!"), _define_property(_obj, CONNOTATIONS.primary, ""), _define_property(_obj, CONNOTATIONS.info, ""), _define_property(_obj, CONNOTATIONS.cta, "Announcement!"), _define_property(_obj, CONNOTATIONS.warning, "Warning!"), _obj);
export var useNotifications = function() {
    var dispatch = useAppDispatch();
    var showNotification = useCallback(function(type, message, header) {
        dispatch(newNotification({
            header: header !== null && header !== void 0 ? header : defaultHeaders[type],
            message: message,
            type: type
        }));
    }, [
        dispatch
    ]);
    var dismissNotification = useCallback(function(id) {
        return dispatch(removeNotification(id));
    }, [
        dispatch
    ]);
    var showSuccess = useCallback(function(message, options) {
        return showNotification(CONNOTATIONS.success, message, options === null || options === void 0 ? void 0 : options.header);
    }, [
        showNotification
    ]);
    var showError = useCallback(function(message, options) {
        return showNotification(CONNOTATIONS.alert, message, options === null || options === void 0 ? void 0 : options.header);
    }, [
        showNotification
    ]);
    var showWarning = useCallback(function(message, options) {
        return showNotification(CONNOTATIONS.warning, message, options === null || options === void 0 ? void 0 : options.header);
    }, [
        showNotification
    ]);
    return {
        dismissNotification: dismissNotification,
        showError: showError,
        showSuccess: showSuccess,
        showWarning: showWarning
    };
};

//# sourceMappingURL=useNotifications.js.map